import { createGlobalStyle } from 'styled-components'

import theme from 'theme'

import { oneTrustStyles } from './oneTrustStyles'

const GlobalDefaultStyles = createGlobalStyle`
  html {
    box-sizing: border-box;
  }

  body {
    background-color:#F5F5F5;
    @media (max-width: ${theme.breakpoints.sm}px) {
      background-color: white;
    }
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: transparent;
  }

  *:focus {
    outline: 0;
  }

  .Resizer {
    opacity: .2;
    z-index: 1;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -moz-background-clip: padding;
    -webkit-background-clip: padding;
    background-clip: padding-box;
  }

  .Resizer.vertical {
    width: 11px;
    margin: 0 -5px;
    border-left: 5px solid rgba(255, 255, 255, 0);
    border-right: 5px solid rgba(255, 255, 255, 0);
    cursor: col-resize;
  }

  .Resizer.vertical {
    width: 11px;
    margin: 0 -5px;
    border-left: 5px solid rgba(255, 255, 255, 0);
    border-right: 5px solid rgba(255, 255, 255, 0);
    cursor: col-resize;
  }

  .Resizer.vertical:hover {
    border-left: 5px solid rgba(0, 0, 0, 0.5);
    border-right: 5px solid rgba(0, 0, 0, 0.5);
  }
  .Resizer.disabled {
    cursor: not-allowed;
  }
  .Resizer.disabled:hover {
    border-color: transparent;
  }

  .Pane2 {
    overflow-y: auto;
  }

  .INDmonochrome .ink {
    display: none;
  }
  .INDwhiteblack .ink {
    display: none;
  }
  .INDlowHue .ink {
    display: none;
  }
  .INDhighHue .ink {
    display: none;
  }
  .INDautoConFix .ink {
    display: none;
  }
  .INDblackwhite .ink {
    display: none;
  }
  .INDbackgroundColors .ink {
    display: none;
  }
  #INDmenu-btn {
    display: none;
  }

  ${oneTrustStyles}
`
export { GlobalDefaultStyles }
